/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay? payWay.routeName : null
}

const getPayWay = function () {

    if(isWechat()){
        return config.payWay.WXPAY;
    }

    if(isAlipay()){
        return config.payWay.ALIPAY;
    }

    return null;

}

const isWechat = function () {
    return navigator.userAgent.indexOf("MicroMessenger") >= 0
}

const isAlipay = function () {
    return navigator.userAgent.indexOf("AlipayClient") >= 0
}

const isMobile = function () {
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Mobile/i.test(navigator.userAgent)
}


export default { getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay,
    isWechat: isWechat,
    isAlipay: isAlipay,
    isMobile: isMobile

}
